import { render, staticRenderFns } from "./jobBoard.vue?vue&type=template&id=6a02b20b"
import script from "./jobBoard.vue?vue&type=script&lang=js"
export * from "./jobBoard.vue?vue&type=script&lang=js"
import style0 from "./jobBoard.vue?vue&type=style&index=0&id=6a02b20b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports